// extracted by mini-css-extract-plugin
export default {"node":"AvYT0","node--is-passed":"UWNsF","node--is-warning":"_7jvZm","node--is-failed":"_6Yc5z"};